var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 6C12.268 6 6 12.268 6 20C6 27.732 12.268 34 20 34C23.282 34.0052 26.4606 32.8521 28.976 30.744L39.866 41.634C39.9821 41.7501 40.1199 41.8422 40.2716 41.905C40.4233 41.9678 40.5858 42.0002 40.75 42.0002C40.9142 42.0002 41.0767 41.9678 41.2284 41.905C41.3801 41.8422 41.5179 41.7501 41.634 41.634C41.7501 41.5179 41.8422 41.3801 41.905 41.2284C41.9678 41.0767 42.0002 40.9142 42.0002 40.75C42.0002 40.5858 41.9678 40.4233 41.905 40.2716C41.8422 40.1199 41.7501 39.9821 41.634 39.866L30.744 28.976C32.8518 26.4604 34.0048 23.2819 34 20C34 12.268 27.732 6 20 6ZM8.5 20C8.5 13.649 13.649 8.5 20 8.5C26.351 8.5 31.5 13.649 31.5 20C31.5 26.351 26.351 31.5 20 31.5C13.649 31.5 8.5 26.351 8.5 20Z",
    fill: "#687078"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchicon);
export default __webpack_public_path__ + "static/media/searchicon.7d9e8966dd7e42230e747ad83f820c09.svg";
export { ForwardRef as ReactComponent };